import { useFetchAllParallelQueries } from 'shared/base/hooks/useFetchAllQueries';

import { XYChart } from './xyChart';
import { XYChartVariant, ReportCardVariantProps } from '../../types';
import { ReportCardWrapper } from '../cardWrapper';
import { XYChartLoader } from './xyChartLoader';
import { mapXYChartData } from '../../mappers';

interface AdditionalProps {
  variantProps: XYChartVariant;
}

export const XYChartReportCard = ({
  clearFilters,
  description,
  sx,
  title,
  variantProps: { queries },
}: ReportCardVariantProps & AdditionalProps) => {
  const queryResults = useFetchAllParallelQueries(queries);

  return (
    <ReportCardWrapper
      clearFilters={clearFilters}
      description={description}
      query={queries.map((query) => query.baseQuery).join(';\n')}
      queryResult={queryResults}
      renderContent={() => undefined}
      renderContentArray={(results) => {
        const mappedData = results.map((result, i) => {
          return {
            data: mapXYChartData(result.data),
            dataKey: queries[i].title,
          };
        });

        return <XYChart data={mappedData} />;
      }}
      renderLoading={() => <XYChartLoader />}
      sx={sx}
      title={title}
    />
  );
};
